<template>
  <div>
    <div class="d-flex justify-content-end mb-2">
      <div @click="toggleOpen" :class="['d-flex', 'align-items-center', 'filters-btn', isOpen ? 'opened' : '']">
        <font-awesome-icon icon="fa-solid fa-filter" class="mr-1" />
        <span>Szűrők</span>
      </div>
    </div>
    <div v-if="isOpen" class="filter-wrapper text-left mb-4">
      <div class="text-right">
        <font-awesome-icon icon="fa-solid fa-xmark" class="p-2 close-btn" @click="toggleOpen" />
      </div>
      <div class="d-lg-flex">
        <div role="group" class="col-lg">
          <label for="currency-filter">Devizanem</label>
          <b-form-select
            id="currency-filter"
            v-model="selectedCurrency"
            :options="currencyOptions"
            @change="emitNewFilters"
          ></b-form-select>
        </div>

        <div role="group" class="col-lg">
          <label for="minimum-value">Minimum összeg</label>
          <b-form-input
            id="minimum-value"
            v-model="minimumValue"
            :state="minimumValueState"
            aria-describedby="minimum-összeg"
            placeholder="Összeg (minimum)"
            type="number"
            min="0"
            class="number-selector"
            @blur="emitNewFilters"
          ></b-form-input>

          <!-- This will only be shown if the preceding input has an invalid state -->
          <b-form-invalid-feedback id="input-live-feedback">
            Legalább 0
          </b-form-invalid-feedback>

          <!-- This is a form text block (formerly known as help block) -->
          <!-- <b-form-text id="input-live-help">Főkategória neve</b-form-text> -->
        </div>

        <div role="group" class="col-lg">
          <label for="maximum-value">Maximum összeg</label>
          <b-form-input
            id="maximum-value"
            v-model="maximumValue"
            :state="null"
            aria-describedby="maximum-összeg"
            placeholder="Összeg (maximum)"
            type="number"
            class="number-selector"
            min="0"
            @blur="emitNewFilters"
          ></b-form-input>

          <!-- This will only be shown if the preceding input has an invalid state -->
          <b-form-invalid-feedback id="input-live-feedback"> </b-form-invalid-feedback>

          <!-- This is a form text block (formerly known as help block) -->
          <!-- <b-form-text id="input-live-help">Főkategória neve</b-form-text> -->
        </div>

        <div role="group" class="col-lg">
          <label for="interest-rate">Kamat mértéke</label>
          <b-form-input
            id="interest-rate"
            v-model="interestRate"
            :state="null"
            aria-describedby="kamat-mértéke"
            placeholder="Kamat mértéke"
            type="number"
            min="0"
            class="number-selector"
            @blur="emitNewFilters"
          ></b-form-input>

          <!-- This will only be shown if the preceding input has an invalid state -->
          <b-form-invalid-feedback id="input-live-feedback"> </b-form-invalid-feedback>

          <!-- This is a form text block (formerly known as help block) -->
          <!-- <b-form-text id="input-live-help">Főkategória neve</b-form-text> -->
        </div>
      </div>
      <div class="d-flex align-items-center justify-content-end mt-3">
        <div @click="resetFilters" class="d-flex align-items-center reset-filters-btn">
          <span>Szűrő törlése</span>
          <font-awesome-icon icon="fa-solid fa-xmark" class="p-2" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      minimumValue: '',
      maximumValue: '',
      interestRate: '',
      minimumTouched: false,
      selectedCurrency: null,
      currencyOptions: [
        { value: null, text: 'Devizanem - mind', disabled: true },
        { value: 'HUF', text: 'Devizanem - HUF' },
        { value: 'USD', text: 'Devizanem - USD' },
        { value: 'EUR', text: 'Devizanem - EUR' }
      ],
      isOpen: false
    }
  },
  computed: {
    minimumValueState() {
      if (!this.minimumTouched) return null
      return this.minimumValue >= 0 ? null : false
    }
  },
  watch: {
    minimumValue() {
      this.minimumTouched = true
    }
  },
  methods: {
    toggleOpen() {
      this.isOpen = !this.isOpen
    },
    resetFilters() {
      this.minimumValue = ''
      this.maximumValue = ''
      this.interestRate = ''
      this.minimumTouched = false
      this.selectedCurrency = null
      this.emitNewFilters()
    },
    emitNewFilters() {
      this.$emit('new-filters-selected', {
        minimumValue: this.minimumValue,
        maximumValue: this.maximumValue,
        interestRate: this.interestRate,
        currency: this.selectedCurrency
      })
    }
  }
}
</script>

<style scoped>
.filter-wrapper {
  padding: 16px 36px;
  border-radius: 8px;
  background-color: #cce9d8;
  box-shadow: 0px 5px 10px rgba(0, 0, 0, 0.05), 0px 15px 25px rgba(0, 0, 0, 0.07);
}

.number-selector {
  border-width: 1px !important;
  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.1);
}

/* Possible fallback idea */
/* #currency-filter.custom-select.select-placeholder-grey {
  color: #636e72;
}
#position-filter.custom-select.select-placeholder-grey {
  color: #636e72;
} */

.filter-wrapper input::placeholder {
  /* Chrome, Firefox, Opera, Safari 10.1+ */
  color: var(--color-gray-05);
  opacity: 1; /* Firefox */
}

.filter-wrapper input:-ms-input-placeholder {
  /* Internet Explorer 10-11 */
  color: var(--color-gray-05);
}

.filter-wrapper input::-ms-input-placeholder {
  /* Microsoft Edge */
  color: var(--color-gray-05);
}

.filter-wrapper label {
  font-size: 10px;
  font-weight: 700;
  color: #2d3436;
}

.reset-filters-btn {
  font-weight: 500;
  font-size: 14px;
  color: #636e72;
  cursor: pointer;
}

.close-btn {
  color: #00903c;
  font-size: 16px;
  font-weight: 900;
  cursor: pointer;
}

.filters-btn {
  color: #00903c;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  border-radius: 50px;
  padding: 5px 10px;
  transition: all 0.2s ease;
}

.filters-btn:hover,
.filters-btn.opened {
  background-color: #cce9d8;
}

@media only screen and (max-width: 992px) and (min-width: 768px) {
  .filter-wrapper {
    padding: 16px 72px;
  }
}
</style>
